/**
 * Returns a URL safe for href. Prepends https:// when there is no protocol.
 */
export const normalizeEndorsementUrlForHref = (url: string | undefined): string => {
	const s = url?.trim() ?? '';
	if (!s) return s;
	if (s.startsWith('http://') || s.startsWith('https://')) return s;
	return `https://${s}`;
};
